import Svg from "@/components/Svg";

const CirclePath = ({ color }) => (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M40 76.7568C60.3002 76.7568 76.7568 60.3002 76.7568 40C76.7568 19.6998 60.3002 3.24324 40 3.24324C19.6998 3.24324 3.24324 19.6998 3.24324 40C3.24324 60.3002 19.6998 76.7568 40 76.7568ZM40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
    fill={color}
  />
);

export default function CardiometabolicIcon({ size = 40, withCircle = true, color }) {
  const viewBox = withCircle ? "0 0 80 80" : "0 0 40 40";
  const iconTransform = withCircle ? "" : "translate(-20 -20)";

  return (
    <Svg
      as="svg"
      width={size}
      height={size}
      minWidth={size}
      minHeight={size}
      viewBox={viewBox}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {withCircle && <CirclePath color={color} />}
      <g transform={iconTransform}>
        <path
          d="M56.6292 26.3887C54.4409 24.2095 51.5598 23.0092 48.4945 23.0092C45.706 23.0092 43.0654 23.9972 40.9786 25.807C38.8826 23.9972 36.2416 23 33.4627 23C30.3972 23 27.5164 24.2004 25.3465 26.3702C22.678 29.0387 21.4961 32.8427 22.1609 36.5454C22.2532 37.044 22.7334 37.3764 23.232 37.2933C23.7306 37.2009 24.063 36.7208 23.9799 36.2222C23.4166 33.1105 24.4138 29.9156 26.6483 27.6814C28.4766 25.8531 30.8958 24.8559 33.4626 24.8559C36.0295 24.8559 38.4488 25.8623 40.2864 27.6814L40.3326 27.7275C40.6927 28.0876 41.2744 28.0876 41.6345 27.7275L41.6807 27.6814C43.4997 25.8623 45.9281 24.8559 48.495 24.8559C51.0711 24.8559 53.4901 25.8623 55.3093 27.6814C57.1375 29.5096 58.1348 31.9288 58.1348 34.4957C58.1348 37.0626 57.1283 39.4818 55.3093 41.3194L40.9512 55.7328L30.6376 46.2682C30.259 45.9266 29.6773 45.9451 29.3356 46.3237C28.994 46.7022 29.0125 47.2839 29.391 47.6256L40.3604 57.6995C40.5358 57.8657 40.7574 57.9396 40.9883 57.9396C41.2283 57.9396 41.4592 57.8473 41.6438 57.6718L56.6297 42.6212C58.7996 40.442 60 37.5518 60 34.4954C60 31.4392 58.7996 28.5581 56.6297 26.3886L56.6292 26.3887Z"
          fill={color}
        />
        <path
          d="M31.0432 42.3347L33.5085 35.5204L38.5595 47.6442C38.6795 47.9489 38.9473 48.1521 39.2704 48.1983C39.3166 48.2075 39.3628 48.2075 39.409 48.2075C39.6767 48.2075 39.9445 48.1059 40.1199 47.8935L44.2381 42.9627H46.648C47.1559 42.9627 47.5714 42.5472 47.5714 42.0394C47.5714 41.5315 47.1559 41.116 46.648 41.116H43.8041C43.5271 41.116 43.2686 41.2176 43.0931 41.43L39.6675 45.5297L34.2937 32.6121C34.1459 32.2612 33.8043 32.0303 33.4165 32.0396C33.0379 32.0488 32.6963 32.3074 32.567 32.6675L29.5199 41.1161H20.9233C20.4155 41.1161 20 41.5316 20 42.0394C20 42.5473 20.4155 42.9628 20.9233 42.9628H30.1752C30.563 42.9628 30.914 42.704 31.0432 42.3347Z"
          fill={color}
        />
      </g>
    </Svg>
  );
}
